window.BAO.Cycler = class Cycler {
  constructor (items) {
    this.items = items
    this.currentPosition = 0
  }

  current () {
    return this.items[this.currentPosition]
  }

  set (val) {
    this.currentPosition = val
  }

  prev () {
    this.currentPosition = this.currentPosition - 1

    if (this.currentPosition < 0) this.currentPosition = this.items.length - 1

    return this.current()
  }

  next () {
    this.currentPosition = (this.currentPosition + 1) % this.items.length

    return this.current()
  }
}
